import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { useTracking } from "../../hooks/useTracking";
import "./CardClinicas.css";

const CardClinica = ({
  clinica,
  highlight = false,
  testName = "",
  hospitalClient = "Vertex_Lab_Direct",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { trackEvent } = useTracking();

  const formatDistance = (distancia) => {
    if (distancia === null || distancia === undefined) return null;

    if (distancia < 1) {
      return `${Math.round(distancia * 1000)} m`;
    }
    return `${distancia.toFixed(1)} km`;
  };

  const distanciaFormateada = formatDistance(clinica.distancia);

  const recommendationType =
    (Array.isArray(clinica.servicios) && clinica.servicios[0]) || "Clinica";

  const handleClinicClick = () => {
    trackEvent("click_recommendation", {
      test_name: testName,
      hospital_client: hospitalClient,
      clinic_name: clinica.nombre,
      recommendation_type: recommendationType,
    });
  };

  const telHref = clinica.telefono
    ? `tel:${String(clinica.telefono).replace(/\s+/g, "")}`
    : undefined;

  return (
    <div className={`card-clinica ${highlight ? "highlighted" : ""}`}>
      <div className="card-clinica-header">
        <h3>{clinica.nombre}</h3>

        {distanciaFormateada && (
          <span className="distance-badge">📍 A {distanciaFormateada}</span>
        )}

        <img src={clinica.img} alt={clinica.nombre} className="clinica-img" />

        <div className="clinica-info-basic">
          <div className="info-item">
            <h4>Dirección:</h4>
            <p>{clinica.direccion}</p>
          </div>
          <div className="info-item">
            <div>
              <h4>Horarios:</h4>
              <p>Lun-Vie: {clinica.horarios.lunesViernes}</p>
              <p>Sáb: {clinica.horarios.sabados}</p>
            </div>
          </div>
          <div className="info-item">
            <h4>Teléfono:</h4>
            {telHref ? (
              <a
                href={telHref}
                className="clinica-tel-link"
                onClick={handleClinicClick}
              >
                {clinica.telefono}
              </a>
            ) : (
              <p>{clinica.telefono}</p>
            )}
          </div>
        </div>

        <button className="toggle-button" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <ChevronUp size={28} /> : <ChevronDown size={28} />}
        </button>
      </div>

      <div className={`servicios-container ${isOpen ? "open" : ""}`}>
        <h4>Servicios:</h4>
        <ul>
          {clinica.servicios.map((servicio, index) => (
            <li key={index}>{servicio}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CardClinica;
